import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IPendingWithdrawalListItem } from '../types';
import {
  PENDING_WITHDRAWALS_LIST_API_URL,
  PENDING_WITHDRAWALS_LIST_QUERY_KEY,
  PENDING_WITHDRAWALS_PERMISSIONS,
} from '../constants';

export default function usePendingWithdrawalsListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IPendingWithdrawalListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IPendingWithdrawalListItem>>({
    queryKey: [PENDING_WITHDRAWALS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IPendingWithdrawalListItem>>(
      PENDING_WITHDRAWALS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: PENDING_WITHDRAWALS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
